import React, { useState, useEffect } from 'react';
import './relief.css';
import PricingButton from './PricingButton'; // Adjust the path as necessary
import { Button } from '@mui/material'; // Ensure you're using Material UI

// Importing images at the top
import char11 from './char11.png';
import char22 from './char22.png';
import char33 from './char33.png';

const Relief = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = /Mobi|Android/i.test(navigator.userAgent);
            setIsMobile(mobileDevice || window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }
    }, []);  // Runs once when the component mounts

    const handlePricingClick = () => {
        window.scrollTo(0, 0); // Scroll to top of the page
        window.location.href = '/contact'; // Navigate to Pricing page
    };

    return (
        <div className='mainCon'>
            <div className="background-image">
                <div className="relief-container">
                    <div className="card">
                        <div className="text-above">
                            <p className="themedTitle">
                                Supporting Our Communities
                            </p>
                            <p className="themedText">
                                We understand the devastating impact that this recent season of hurricanes and wildfires has had, which is why we're donating 10% of proceeds to help recovery efforts and affected communities.
                            </p>
                        </div>

                        <p className="themedText3">
                            Your business will directly support one of the following great organizations.
                        </p>
                        {/* Conditional rendering for mobile and web */}
                        {!isMobile ? (
                            <>
                                {/* Mobile version: Image container first, then the text */}
                                <div className="relief-images">
                                    <a href="https://www.directrelief.org/emergency/hurricanes/" target="_blank" rel="noopener noreferrer">
                                        <img src={char11} alt="Help 1" className="relief-image" />
                                    </a>
                                    <a href="https://onemorechild.org/our-care/family-support-services/" target="_blank" rel="noopener noreferrer">
                                        <img src={char22} alt="Help 2" className="relief-image" />
                                    </a>
                                    <a href="https://www.salvationarmyusa.org/usn/wildfire-relief/" target="_blank" rel="noopener noreferrer">
                                        <img src={char33} alt="Help 3" className="relief-image" />
                                    </a>
                                </div>
                                <p className="themedText4">
                                    Click to learn more!
                                </p>
                            </>
                        ) : (
                            <>
                                {/* Web version: Text first, then the image container */}
                                <p className="themedText4">
                                    Click to learn more!
                                </p>
                                <div className="relief-images">
                                    <a href="https://www.directrelief.org/emergency/hurricanes/" target="_blank" rel="noopener noreferrer">
                                        <img src={char11} alt="Help 1" className="relief-image" />
                                    </a>
                                    <a href="https://onemorechild.org/our-care/family-support-services/" target="_blank" rel="noopener noreferrer">
                                        <img src={char22} alt="Help 2" className="relief-image" />
                                    </a>
                                    <a href="https://www.salvationarmyusa.org/usn/wildfire-relief/" target="_blank" rel="noopener noreferrer">
                                        <img src={char33} alt="Help 3" className="relief-image" />
                                    </a>
                                </div>
                            </>
                        )}

                    </div>
                </div>

                <div style={{ width: '100%', textAlign: 'center', marginBottom: '0px', fontFamily: 'Medium', justifyContent: 'center', alignContent: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={handlePricingClick}
                        style={{ width: '80%', fontFamily: 'Medium', backgroundColor: '#336699', color: '#fff', maxWidth: '600px', marginTop: '.5%', marginBottom: '30%', borderRadius: '7.5px', padding: '1%', fontSize: '1.25rem', justifyContent: 'center', alignContent: 'center' }}
                    >
                        Book a free app consultation
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Relief;
